import React from "react";

import { createSvgIconComponent } from "../utils";

export const IconHamburger = createSvgIconComponent({
  children: [
    <rect
      key="part-1"
      x="4"
      y="6"
      width="16"
      height="2"
      rx="1"
      fill="currentColor"
    />,
    <rect
      key="part-2"
      x="4"
      y="11"
      width="16"
      height="2"
      rx="1"
      fill="currentColor"
    />,
    <rect
      key="part-3"
      x="4"
      y="16"
      width="16"
      height="2"
      rx="1"
      fill="currentColor"
    />,
  ],
  viewBox: "0 0 24 24",
});
